/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Deck_Building_DescriptionInputs */



/**
* | output |
* | --- |
* | "Plan your deck by picking cards, filling zones, and validating against Constructed format rules." |
*
* @param {Help_Article_Deck_Building_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_deck_building_description = /** @type {((inputs?: Help_Article_Deck_Building_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Deck_Building_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plane dein Deck: Karten auswählen, Zonen füllen und gegen die Regeln des Constructed-Formats prüfen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Planifiez votre deck en choisissant des cartes, en remplissant les zones et en validant selon les règles du format construit.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("通过挑选卡牌、填满各个区域并按 Constructed 赛制规则校验，来规划你的卡组。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("挑選卡牌、填滿各個區域，並依 Constructed 賽制規則驗證，規劃你的牌組。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드를 고르고 각 구역을 채우며 사전 구성 형식 규칙에 맞는지 확인해 덱을 설계하세요.")
	return /** @type {LocalizedString} */ ("Plan your deck by picking cards, filling zones, and validating against Constructed format rules.")
});